<template>
  <v-dialog v-model="localDialog" width="40%" @update:modelValue="updateDialog" transition="persistent" :open-delay="0" :close-delay="0">
    <v-card>
        <v-card-title class="text-h6">
            <span>{{ isEntryMode ? 'Add Approval name' : 'Update Approval Name' }}</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
            <v-form @submit.prevent="submit" ref="approvalNameForm">
              <v-row>
                  <v-col cols="12">  
                        <v-autocomplete
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          v-model="module_id.value.value"
                          :items="getModuleList.filter(item=> item.status == 1)"
                          :item-title="item => item && item.name && item.code ? `${item.name} - ${item.code}` : ''"    
                          @update:modelValue="() => { 
                            sub_module_id.value.value = null;
                            menu_id.value.value = null;
                          }"
                          item-value="id"
                          autocomplete = "off"
                          :error-messages="isDataLoading ? '' : module_id.errorMessage.value"
                          clearable                        
                        >
                        <template #label>
                          Module <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete> 

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="sub_module_id.value.value"
                        :items="getSubModuleList.filter(item=> item.status == 1 && item.module_id == module_id.value.value)"
                        :item-title="item => item && item.name && item.code ? `${item.name} - ${item.code} (${item.module.name})` : ''"
                        @update:modelValue="handleSubModuleChange"
                        item-value="id"
                        autocomplete="off"
                        :error-messages="isDataLoading ? '' : sub_module_id.errorMessage.value"
                        clearable                        
                      >
                        <template #label>
                          Sub Module <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete> 


                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="menu_id.value.value"
                        :items="getMenuList"
                        :item-title="item => item && item.name && item.code ? `${item.name} - ${item.code}` : ''"
                        item-value="id"
                        autocomplete="off"
                        @update:modelValue="handleMenuChange"
                        :error-messages="isDataLoading ? '' : menu_id.errorMessage.value"
                        :loading="loading"
                        clearable                        
                      >
                        <template #label>
                          Menu <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete> 

                      <v-text-field
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="name.value.value"
                      
                          :error-messages="name.errorMessage.value"
                          clearable
                      >
                        <template #label>
                          Name <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                      <!-- <v-text-field
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="tag.value.value"
                          :error-messages="tag.errorMessage.value"
                          clearable
                      >
                        <template #label>
                          Tag <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field> -->

                      <!-- <v-text-field
                          label="Show URL"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="show_url.value.value"
                          :error-messages="show_url.errorMessage.value"
                          clearable
                      ></v-text-field> -->

                       <!-- <v-text-field
                          label="Edit URL"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="edit_url.value.value"
                          :error-messages="edit_url.errorMessage.value"
                          clearable
                      ></v-text-field>     -->

                       <v-row>
                          <v-col cols="6">
                            <v-checkbox                            
                              label="Active"
                              v-model="status.value.value"
                              :error-messages="status.errorMessage.value"
                              density="compact"
                              variant="outlined"
                              hide-details
                              single-line
                              color="primary"
                              value="1"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="6">
                            <v-checkbox                            
                              label="Is Forward"
                              v-model="is_forward.value.value"
                              :error-messages="is_forward.errorMessage.value"
                              density="compact"
                              variant="outlined"
                              hide-details
                              single-line
                              color="primary"
                              value="1"
                            ></v-checkbox>
                          </v-col>
                       </v-row>
                      <input v-model="approval_name_id.value.value" type="hidden">                              
                  </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-card-actions>
                  <v-layout class="justify-end">
                      <v-btn class="bg-red" variant="flat" type="reset" @click="closeDialog">Close</v-btn>
                        <v-btn 
                        class="bg-brand w-15 ms-2"  
                        variant="flat" 
                        type="submit"
                        >
                        {{ isEntryMode ? 'Save' : 'Update' }}
                        </v-btn>
                  </v-layout>
              </v-card-actions>
            </v-form>
        </v-card-text>
      
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { toast } from 'vue3-toastify'
import Axios from 'axios'
import { prefix } from '@/store/api'

export default {
  name: 'ApprovalName',
  emits: ['update:dialog'],
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({
        name: '',
        show_url: '',
        tag: '',
        status: '1',
        is_forward: '1',
        module_id: null,
        sub_module_id: null,
        menu_id: null,
        approval_name_id: null
      })
    }
  },
  data() {
    return {
      localDialog: this.dialog || false,
      selectedImage: null,
      errorMessages: '',
      preview: '/src/assets/no_preview.jpeg',
      loading: false,
      selectedFavshow_url: null,
      isEntryMode: true,
      isDataLoading: false,
    }
  },
  computed: {
    getModuleList() {
      return this.$store.getters.getModuleList;
    },
    getSubModuleList() {
      return this.$store.getters.getSubModuleList;
    },
    getMenuList() {
      return this.$store.getters.getMenuList;
    },
  },
  watch: {
    dialog(val) {
      this.localDialog = val
    },
    localDialog(val) {
      this.$emit('update:dialog', val)
    },
    data: {
      async handler(newData) {
        this.isDataLoading = true;
        this.isEntryMode = !newData.id;
        this.name.setValue(newData.name || '', false);
        this.show_url.setValue(newData.show_url || '', false);
        this.tag.setValue(newData.tag || '', false);
        this.status.setValue(String(newData.status) || '1', false);
        this.is_forward.setValue(String(newData.is_forward) || '1', false);
        this.module_id.setValue(newData.module_id || null, false);
        this.sub_module_id.setValue(newData.sub_module_id || null, false);
        this.approval_name_id.setValue(newData.id || '', false);
        
        // Load menu list when updating (if sub_module_id exists)
        if (newData.sub_module_id && !this.isEntryMode) {
          await this.handleSubModuleChange(newData.sub_module_id);
        }
        
        // Set menu_id after loading the menu list
        this.menu_id.setValue(newData.menu_id || null, false);
        
        // Reset form validation after all values are set
        this.resetForm({ errors: {}, touched: {}, values: {
          name: newData.name || '',
          show_url: newData.show_url || '',
          tag: newData.tag || '',
          status: String(newData.status) || '1',
          is_forward: String(newData.is_forward) || '1',
          module_id: newData.module_id || null,
          sub_module_id: newData.sub_module_id || null,
          menu_id: newData.menu_id || null,
          approval_name_id: newData.id || ''
        }});
        
        this.isDataLoading = false;
      },
    }
    
  },
  created() {
      const loadData = async () => {
        try {
          this.loading = true;
          const promises = [];
          
          if(this.$store.getters.getModuleList.length === 0) {
            promises.push(this.$store.dispatch('getModuleList'));
          }
          
          if(this.$store.getters.getSubModuleList.length === 0) {
            promises.push(this.$store.dispatch('getSubModuleList'));
          }
          
          if(this.$store.getters.getMenuList.length === 0) {
            promises.push(this.$store.dispatch('getMenuList'));
          }
          
          await Promise.all(promises);
        } catch (error) {
          console.error('Error loading data:', error);
        } finally {
          this.loading = false;
        }
      };
      
      loadData();
  },
  methods: {
    clearFavshow_url() {
        this.selectedFavshow_url = null;
    },
    updateDialog(val) {
      this.$emit('update:dialog', val)
    },
    closeDialog() {
        this.$emit('update:dialog', false);
    },
    async handleSubModuleChange(value) {
        this.menu_id.value.value = null;
        if (value) {
            try {
                this.loading = true;
                const response = await Axios.get(prefix + `administration/get-approval-sub-module-by-menu?sub_module_id=${value}`);
                if (response.data.success) {
                    this.$store.commit('SET_MENU_BY_SUBMODULE', response.data.data);
                }
            } catch (error) {
                console.error('Error fetching menus:', error);
                toast.error('Failed to fetch menu list');
            } finally {
                this.loading = false;
            }
        } else {
            this.$store.commit('UNSET_MENU_LIST');
        }
    },
    handleMenuChange(value) {
        if (value) {
            const selectedMenu = this.getMenuList.find(menu => menu.id === value );
            if (selectedMenu) {
                this.name.value.value = selectedMenu.name + ' (Approval)';
            }
        } else {
            this.name.value.value = '';
        }
    },
  },
  setup(props, { emit }){
    const { handleSubmit, resetForm} = useForm({
      validationSchema: yup.object({
          name: yup.string().min(1).max(300).required().trim().label('Name'),
          // show_url: yup.string().min(1).max(50).nullable().trim().label('Show URL'),
          // edit_url: yup.string().min(1).max(50).nullable().trim().label('Edit URL'),
          // tag: yup.string().min(1).max(50).required().label('tag'),
          module_id: yup.number().positive().integer().nullable().required().label('Module Name'),
          sub_module_id: yup.number().positive().integer().nullable().required().label('Sub Module Name'),
          menu_id: yup.number().positive().integer().nullable().required().label('Menu'),
      }),

    });

    const name = useField('name');
    const show_url = useField('show_url');
    const edit_url = useField('edit_url');
    const tag = useField('tag');
    const status = useField('status');
    const is_forward = useField('is_forward');
    const module_id = useField('module_id');
    const sub_module_id = useField('sub_module_id');
    const menu_id = useField('menu_id');
    const approval_name_id = useField('approval_name_id');
    const errorMessages  = ref('');
    const loading  = ref('');
    const buttonText  = ref('');
    buttonText.value = 'Save';
    const store = useStore();

    const submit = handleSubmit(async (values) => {
        try {
            loading.value = true;
            // Ensure is_forward is 0 or 1
            const formValues = {
                ...values,
                is_forward: values.is_forward === '1' || values.is_forward === 1 ? '1' : '0'
            };
            const response = await store.dispatch("saveUpdateApprovalName", formValues);
            resetForm();
            emit('update:dialog', false);
            toast.success(response.data.message, {
                timeout: 1000,
            });
            
            await store.dispatch('getApprovalNameList');
            toast.success('List updated successfully');
        } catch (error) {
            console.error('Error:', error);
            toast.error(error.response?.data?.message || 'An error occurred');
        } finally {
            loading.value = false;
        }
    });
    return {
      submit,
      name,
      show_url,
      edit_url,
      tag,
      status,
      is_forward,
      errorMessages,
      approval_name_id,
      buttonText,
      module_id,
      sub_module_id,
      menu_id,
      resetForm,
      loading
    }
  },
  mounted() {
  }
}
</script>

